export default __webpack_public_path__ + "static/media/001_BANNER_TECNOLOGIA_POTENCIA_BANNER_01.b292c6c6.jpg";